import type { BadgeColor } from "components/common/ui/Badge";

export const claimBadgeColor: { [key: string]: BadgeColor } = {
  submitted: "blue",
  inReview: "yellow",
  resolved: "green",
  denied: "grey",
  actionRequired: "red",
};
